"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isError = void 0;
function isError(json) {
    return json && json.success === false;
}
exports.isError = isError;



//////////////////
// WEBPACK FOOTER
// ./src/client/api/is-error.ts
// module id = 1002
// module chunks = 0 1 2